import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum PcInventoryLocationFormFields {
	processingCenterId = 'processingCenterId',
	name = 'name',
	isDefault = 'isDefault',
	isActive = 'isActive',
	isFinal = 'isFinal'
}

export enum PcInventoryLocationSearchResultFields {
	searchByName = 'searchByName'
}

export enum PcInventoryLocationFilterFields {
	includeInactive = 'includeInactive',
	processingCenterId = 'processingCenterId'
}

export declare namespace PcInventoryLocation {
	interface Basic extends Entity {
		processingCenterId: number
		processingCenterName: string
		isDefault: boolean
		isFinal: boolean
		isActive: boolean
	}
	namespace Form {
		interface Generic {
			name: string
			processingCenterId: number | null
			isDefault: boolean
			isFinal: boolean
			isActive: boolean
		}
	}
	namespace Request {
		interface Generic {
			name: string
			processingCenterId: number
			isDefault: boolean
			isFinal: boolean
			isActive: boolean
		}
	}

	namespace Search {
		interface Result {
			[PcInventoryLocationSearchResultFields.searchByName]: Entity[]
		}
		interface Config {
			[PcInventoryLocationSearchResultFields.searchByName]: ConfigItem<PcInventoryLocationSearchResultFields>
		}
	}

	namespace Filters {
		export interface Config {
			[PcInventoryLocationFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
			[PcInventoryLocationFilterFields.processingCenterId]: ConfigFilterItem<string, string>
		}
	}
}
